import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { CloseDesignerDialogComponent
       } from './close-designer-dialog/close-designer-dialog.component';
import { DeleteGalleryImageDialogComponent
       } from './delete-gallery-image-dialog/delete-gallery-image-dialog.component'; // eslint-disable-line
import { DeletePlaceholderDialogComponent
       } from './delete-placeholder-dialog/delete-placeholder-dialog.component';
import { DialogButtonsComponent } from './dialog-buttons.component';
import { DialogComponent } from './dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ImageQualityDialogComponent
       } from './image-quality-dialog/image-quality-dialog.component'; // eslint-disable-line
import { ProductChooserWarningDialogComponent } from './productchooser-warning-dialog/productchooser-warning-dialog.component'; // eslint-disable-line
import { SmartSortedDialogComponent
       } from './smart-sorted-dialog/smart-sorted-dialog.component';
import { UnchangedPlaceholdersDialogComponent
       } from './unchanged-placeholders-dialog/unchanged-placeholders-dialog.component'; // eslint-disable-line

@NgModule({
  imports: [
    CommonModule,
    MatModule,
    FormsModule,
    TranslationModule,
  ],
  declarations: [
    DialogButtonsComponent,
    DialogComponent,
    ErrorDialogComponent,
    UnchangedPlaceholdersDialogComponent,
    CloseDesignerDialogComponent,
    DeleteGalleryImageDialogComponent,
    DeletePlaceholderDialogComponent,
    ProductChooserWarningDialogComponent,
    SmartSortedDialogComponent,
    ImageQualityDialogComponent,
  ],
  exports: [
    DialogButtonsComponent,
    DialogComponent,
    ErrorDialogComponent,
    UnchangedPlaceholdersDialogComponent,
    CloseDesignerDialogComponent,
    DeleteGalleryImageDialogComponent,
    DeletePlaceholderDialogComponent,
    ProductChooserWarningDialogComponent,
    SmartSortedDialogComponent,
    ImageQualityDialogComponent,
  ],
})
export class DialogsModule { }
